import React from 'react'
import PropTypes from 'prop-types'
import {
  SeparatorSecondary,
  ParagraphSecondary,
  SpacerVertical,
  SpacerHorizontal
} from 'mage-deps/@klarna/bubble-ui'

KeyValueList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.node.isRequired,
      value: PropTypes.node.isRequired
    })
  ).isRequired
}

function KeyValueList({ items }) {
  return (
    <div>
      {items.map(({ key, value }, idx) => {
        return (
          <ParagraphSecondary key={idx}>
            {idx > 0 ? <SeparatorSecondary /> : null}
            <SpacerVertical extraSmall />
            <div
              style={{ display: 'flex', justifyContent: 'space-between', width: '100%', flex: 1 }}
            >
              <div>{key}</div>
              <SpacerHorizontal small />
              <div style={{ fontWeight: 700 }}>{value}</div>
            </div>
            <SpacerVertical extraSmall />
          </ParagraphSecondary>
        )
      })}
    </div>
  )
}

export default KeyValueList
